module.exports = __webpack_public_path__ + "img/8F1FD59A-EAF6-4CCA-8D19-B8A303156022_1_201_a-min.93bd2c43.jpeg";